import { Icon } from 'components';
import { memo } from 'react';

import * as Styles from './styles';

const ArchivePlaceholderComponent = (): JSX.Element => {
  return (
    <Styles.ArquiveContainer>
      <Icon name="folder" size={2} />

      <Styles.DownloadIconContainer>
        <Icon name="download" size={2} />
      </Styles.DownloadIconContainer>
    </Styles.ArquiveContainer>
  );
};

export const ArchivePlaceholder = memo(ArchivePlaceholderComponent);
